import NumberFormat from 'react-number-format'
import React from 'react'
import { Input } from 'components/ui'

const NumberFormatInput = ({ onValueChange, ...rest }) => {
    return (
        <NumberFormat
            customInput={Input}
            type="text"
            onValueChange={onValueChange}
            autoComplete="off"
            {...rest}
        />
    )
}

export default NumberFormatInput
